<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app'
  }
</script>
<style>
@import "assets/style/index.css";
.tab-item{
  float:left;
  font-weight:bold;
  width:100px;
  line-height:30px;
  text-align:center
}

</style>



// WEBPACK FOOTER //
// src/App.vue